export default __webpack_public_path__ + "static/media/services_hospitality.58533254.jpg";